// extracted by mini-css-extract-plugin
export default {"wrapper":"Eajot","panel":"W0MTI","expanded":"Vk7ZH","menu":"xJk5j","up":"CF21J","buttons":"vLoFn","devPanel":"hAuCL","withMessangers":"wzvuY"};